import { observer } from 'mobx-react-lite'
import React, { SyntheticEvent } from 'react'
import { Button, Reveal } from 'semantic-ui-react';
import { UserActivity } from '../../app/models/userActivity';
import { useStore } from '../../app/stores/store';

interface Props {
    profile: UserActivity;
}

function FollowTaglleButton(props: Props) {
    const usStore = useStore();

    if (usStore.userStore.user?.userName === props.profile.userName) { return null; } //' do not display button 

    function handleFollowTaglle(event: SyntheticEvent) {
        event.preventDefault(); //' prevent link navigation on ProfileCard
        
        props.profile.bFollowing ? usStore.profileStore.followTaggle(props.profile.userName, false) : usStore.profileStore.followTaggle(props.profile.userName, true) ;
    }

    return (
        <Reveal animated='move' >
            <Reveal.Content visible style={{width: '100%'}} >
                <Button 
                    //content='Following' 
                    content={props.profile.bFollowing ? 'Following' : 'Not following' }
                    color='teal' 
                    fluid 
                />
            </Reveal.Content>
            <Reveal.Content hidden style={{width: '100%'}} >
                {/* <Button content={true ? 'Unfollow' : 'Follow'} color={true ? 'red' : 'green' } basic fluid  /> */}
                <Button 
                    content={props.profile.bFollowing ? 'Unfollow' : 'Follow'} 
                    color={props.profile.bFollowing ? 'red' : 'green'} 
                    basic 
                    fluid 
                    onClick={(event) => handleFollowTaglle(event)} 
                    loading={usStore.profileStore.isLoading}
                />
            </Reveal.Content>
        </Reveal>
    )
}

export default observer(FollowTaglleButton);